import {useQuery} from "react-query";
import ModeOfTransportationBreakdownByMonthApi from "./ModeOfTransportationBreakdownByMonth.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useModeOfTransportationBreakdownByMonth(query:IWidgetQuery){
    return useQuery(["fetchModeOfTransportationBreakdownByMonth", query], ModeOfTransportationBreakdownByMonthApi.getData);
}